import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';
import { AsyncPipe, TitleCasePipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
  input,
  viewChild,
} from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';
import { AvatarModule } from 'primeng/avatar';
import { SelectModule } from 'primeng/select';
import { StyleClassModule } from 'primeng/styleclass';
import { ShortNamePipe } from '@fitness-force/pipes/short-name';
import type { STAFFINTERFACE } from '@fitness-force/models';
import { StaffStoreService } from '@fitness-force/api';
@Component({
  selector: 'staff-info',
  templateUrl: './staff-info.component.html',
  styleUrls: ['./staff-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    AvatarModule,
    SelectModule,
    StyleClassModule,
    ShortNamePipe,
    PopoverModule,
    AsyncPipe,
    TitleCasePipe,
  ],
})
export class StaffInfoComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly staffStoreService = inject(StaffStoreService);

  readonly staffId = input(0);
  localStaffId: number = 0;
  columnData: Observable<any> = new BehaviorSubject(null);
  additionData: Observable<any> = new BehaviorSubject(null);
  dataProperty: string = '';

  readonly op = viewChild<Popover>('op');
  staffInfo: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  ngOnInit(): void {
    if (this.staffId() && this.staffId() != 0) {
      this.localStaffId = this.staffId();
      this.loadStaff();
    } else {
      this.columnData.subscribe({
        next: (cData: any) => {
          if (cData && this.dataProperty) {
            this.localStaffId = cData[this.dataProperty] || 0;
            this.loadStaff();
          }
        },
      });
    }
  }

  loadStaff() {
    const idToLoad = this.localStaffId || this.staffId();
    if (idToLoad && idToLoad > 0) {
      this.staffStoreService
        .getStaffById(idToLoad)
        .subscribe((staff: STAFFINTERFACE) => {
          this.staffInfo.next(staff);
        });
    } else {
      this.staffInfo.next(null);
    }
    // this.store.pipe(
    //   select(STAFF_STATE),
    //   map((loaded) => {
    //     return loaded.staffListAll.filter((value) => value.id == this.staffId);
    //   }),
    //   mergeMap((value) => value)
    // ).subscribe({
    //   next: (staff:any) => {
    //     this.staffInfo.next(staff);
    //   },
    // });
  }
  toggleOverlay = (event: any) => this.op()?.toggle(event);
  show = (event: any) => this.op()?.show(event);
  hide = () => this.op()?.hide();
}
